// Quote display only. Customer billing and order creation continue to use USD.
export function normalizeQuoteExchangeRate (value) {
  const rate = String(value == null ? '' : value).trim()
  if (!/^\d+(?:\.\d{1,4})?$/.test(rate) || Number(rate) <= 0 || Number(rate) > 100) return null
  return String(Number(rate))
}

export function approximateCny (usdAmount, exchangeRate) {
  const amount = String(usdAmount == null ? '' : usdAmount).trim()
  const rate = String(exchangeRate == null ? '' : exchangeRate).trim()
  if (!/^\d+(?:\.\d{1,2})?$/.test(amount) || !/^\d+(?:\.\d{1,4})?$/.test(rate)) return null
  const [usdWhole, usdFraction = ''] = amount.split('.')
  const [rateWhole, rateFraction = ''] = rate.split('.')
  const cents = Number(usdWhole) * 100 + Number(usdFraction.padEnd(2, '0'))
  const rateUnits = Number(rateWhole) * 10000 + Number(rateFraction.padEnd(4, '0'))
  const multiplied = cents * rateUnits
  if (!Number.isSafeInteger(multiplied) || rateUnits <= 0) return null
  return (Math.floor((multiplied + 5000) / 10000) / 100).toFixed(2)
}
